import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const PickProductsApprovel = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [advisedChanges, setAdvisedChanges] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          'https://api.bakpoket.com/api/AdminContent/admin/merchant-products'
        );

        // console.log("API Response:", response.data);

        // ✅ Adjust depending on API structure
        if (Array.isArray(response.data)) {
          setData(response.data);
        } else if (Array.isArray(response.data?.data)) {
          setData(response.data.data);
        } else if (Array.isArray(response.data?.products)) {
          setData(response.data.products);
        } else {
          setData([]);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
      }
    };
    fetchProducts();
  }, []);

  const handleApprove = async (item) => {
    const payload = {
      productId: item.id,
      isApproved: true,
      rejectReason: '',
      advisedChanges: ''
    };

    try {
      await axios.post(
        'https://api.bakpoket.com/api/AdminContent/admin/merchant-products/update-status',
        payload
      );
      alert('Product approved successfully');
      setData(prev => prev.map(p => (p.id === item.id ? { ...p, isApproved: true } : p)));
    } catch (error) {
      console.error('Approval failed:', error);
      alert('Failed to approve product');
    }
  };

  const handleReject = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleModalSubmit = async () => {
    if (!rejectReason.trim()) {
      alert('Reject reason is required');
      return;
    }

    const payload = {
      productId: selectedItem.id,
      isApproved: false,
      rejectReason,
      advisedChanges
    };

    try {
      await axios.post(
        'https://api.bakpoket.com/api/AdminContent/admin/merchant-products/update-status',
        payload
      );
      alert('Product rejected successfully');
      setData(prev => prev.map(p => (p.id === selectedItem.id ? { ...p, isApproved: false } : p)));
      setShowModal(false);
      setRejectReason('');
      setAdvisedChanges('');
    } catch (error) {
      console.error('Rejection failed:', error);
      alert('Failed to reject product');
    }
  };

  return (
    <Card>
      <TableWrapper>
        <h3 className='text-center text-md-start'>Products Overview</h3>
        <table>
          <thead>
            <tr>
              <th className='text-center'>Product Name</th>
              <th className='text-center'>Price</th>
              <th className='text-center'>Action</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td className='text-center'>{item.productName}</td>
                  <td className='text-center'>{item.price}</td>
                  <td className='text-center'>
                    {item.isApproved ? (
                      <button className="reject-btn" onClick={() => handleReject(item)}>
                        Reject
                      </button>
                    ) : (
                      <button className="approve-btn" onClick={() => handleApprove(item)}>
                        Approve
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center' }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableWrapper>

      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <h4>Reject Product</h4>
            <label>Reject Reason*</label>
            <textarea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              rows="3"
            />
            <label>Advised Changes</label>
            <textarea
              value={advisedChanges}
              onChange={(e) => setAdvisedChanges(e.target.value)}
              rows="3"
            />
            <div className="modal-buttons">
              <button onClick={handleModalSubmit}>Submit</button>
              <button className="cancel" onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </Card>
  );
};

export default PickProductsApprovel;


// Styled Components
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 900px;
  width: 100%;
  margin: auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  .approve-btn,
  .reject-btn {
    padding: 6px 12px;
    background-color: #ef4766;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #d63c5b;
    }
  }

  @media (max-width: 768px) {
    padding: 20px;

    h2 {
      font-size: 16px;
    }

    .approve-btn,
    .reject-btn {
      font-size: 11px;
      padding: 5px 10px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const TableWrapper = styled.div`
  margin-top: 20px;
  overflow-x: auto;
  overflow-y: auto;

  h3 {
    color: #2a4157;
    font-size: 18px;
    margin-bottom: 10px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th, td {
      border: 1px solid #ccc;
      padding: 8px 10px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 13px;
      margin-bottom: 7px;
    }

    table {
      font-size: 10px;

      th, td {
        padding: 6px 4px;
      }
    }
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background: white;
  padding: 15px;
  border-radius: 12px;
  max-width: 400px;
  width: 80%;

  h4 {
    margin-bottom: 10px;
    color: #2a4157;
  }

  label {
    display: block;
    margin: 8px 0 4px;
    font-weight: bold;
    font-size: 14px;
  }

  textarea {
    width: 100%;
    padding: 5px;
    border-radius: 6px;
    border: 1px solid #ccc;
    resize: none;
  }

  .modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-top: 20px;

    button {
      padding: 8px 12px;
      border: none;
      border-radius: 6px;
      background: #ef4766;
      color: white;
      cursor: pointer;

      &.cancel {
        background: #ccc;
        color: #333;
      }
    }
  }
`;
